import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "itemBillerSelector", "itemSummary", "allTopSellingSummary" ]

  connect() {
    this.filterSummaries();
  }

  filterSummaries() {
    const selectedBillerId = this.itemBillerSelectorTarget.value;

    this.itemSummaryTargets.forEach((summary) => summary.style.display = "none");
    if (this.allTopSellingSummaryTarget) {
      this.allTopSellingSummaryTarget.style.display = "none";
    }

    if (selectedBillerId === "all") {
      if (this.allTopSellingSummaryTarget) {
        this.allTopSellingSummaryTarget.style.display = "block";
      }
    } else if (selectedBillerId) {
      const summary = this.itemSummaryTargets.find(
          s => s.dataset.billerId === selectedBillerId
      );
      if (summary) summary.style.display = "block";
    }
  }
}
